export default {
      id: "facebook-usage",
      viewBox: "0 0 320 512",
      url: __webpack_public_path__ + "icons.svg#facebook",
      toString: function () {
        return this.url;
      }
    }